import type { SurgeonDto } from '@peritasai/types';

export class SurgeonEntity {
  public readonly id: string;
  public readonly firstName: string | null;
  public readonly lastName: string | null;
  public readonly fullName: string | null;
  public readonly npiNumber: string | null;
  public readonly specialty: string | null;
  public readonly providerId: string | null;
  public readonly active: boolean;

  constructor(dto: SurgeonDto) {
    this.id = dto.id;
    this.firstName = dto.firstName ?? null;
    this.lastName = dto.lastName ?? null;
    this.fullName = dto.fullName ?? null;
    this.npiNumber = dto.npiNumber ?? null;
    this.specialty = dto.specialty ?? null;
    this.providerId = dto.providerId ?? null;
    this.active = dto.isActive ?? true;
  }
}
